export const BUGIAM_USER_SET_EVENT = 'bugiam:user:set';
export const BUGIAM_USER_CLEAR_EVENT = 'bugiam:user:clear';

export function dispatchBugIAmUserSet(user: unknown): void {
  window.dispatchEvent(new CustomEvent(BUGIAM_USER_SET_EVENT, { detail: user }));
}

export function dispatchBugIAmUserClear(): void {
  window.dispatchEvent(new CustomEvent(BUGIAM_USER_CLEAR_EVENT));
}
